/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  return /^(vaccinated|unvaccinated)$/.test(param)
}
